export default "__VITE_ASSET__321c580f__"